export default __webpack_public_path__ + "swim-green.svg";